
import hasModel from '@/mixins/hasModel'
import queryParams from '~/mixins/queryParams'

export default {
    mixins: [queryParams, hasModel],

    async fetch() {
        if (this.model.slug) {
            const response = await this.$axios.$get(
                `${this.queryParams('/api/v1/content/list', {
                    content_type: this.model.slug,
                    with_children: true,
                    flat_list: true,
                    per_page: 100,
                })}`
            )
            this.taxonomy = response.data
        }
    },

    data() {
        return {
            taxonomy: [],
        }
    },

    computed: {
        taxonomyLength() {
            return this.taxonomy?.length
        },
    },

    watch: {
        taxonomyLength() {
            if (process.browser) {
                this.$nextTick(() => {
                    window.dispatchEvent(new Event('resize'))
                })
            }
        },
    },
}
